import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetUserTakeoutListUseCase extends UseCase {
  constructor({service, log}) {
    super()

    this._service = service
    this._log = log
  }

  /**
   * @return {Promise<Object, Error>}
   */

  execute({useTranscendAPI = false} = {}) {
    this._log('Getting user takeout list')
    return this._service
      .execute({useTranscendAPI})
      .then(userTakeoutListValueObject => userTakeoutListValueObject.toJSON())
      .catch(e => Promise.reject(Error(`GetUserTakeoutListUseCase[execute] has had an error: ${e}`)))
  }
}
